export enum MessageBoxTypes {
  Confirm = 'Confirm',
  Error = 'Error',
  Information = 'Information',
  Success = 'Success',
  Warning = 'Warning',
  Highlight = 'Highlight'
}
